module.exports = __webpack_public_path__ + "img/st-select.7c19633c.png";